var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component",attrs:{"tag":_vm.tag,"enter-active-class":"fadeIn","leave-active-class":"fadeOut","move-class":"fade-move"}},'component',_vm.$attrs,false),_vm.hooks),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }